import { Grid, Typography } from "@mui/material";
import { DialogInfoItem } from "./DialogInfoItem";
import { PVSyst } from "../types";
import { MonthAndYearValuesList } from "./MonthAndYearValuesList";

export function PVSystInfo(props: { pvSyst: PVSyst }) {
  const { pvSyst } = props;
  return (
    <Grid paddingX={"10px"} spacing={2} container style={{ overflowY: "auto" }}>
      <MonthAndYearValuesList title="GlobHor" values={pvSyst.globHor} />
      <MonthAndYearValuesList title="E_Grid" values={pvSyst.e_Grid} />
      <MonthAndYearValuesList title="PR" values={pvSyst.pr} />
      <MonthAndYearValuesList title="GlobInc" values={pvSyst.globInc} />
      <Grid item xs={12} sm={6}>
        <Typography sx={{ fontWeight: "bold" }}>Localização</Typography>
        <DialogInfoItem
          name="Latitude"
          value={pvSyst.latitude ?? "Não informado"}
        />
        <DialogInfoItem
          name="Longitude"
          value={pvSyst.longitude ?? "Não informado"}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography sx={{ fontWeight: "bold" }}>Módulos</Typography>
        <DialogInfoItem
          name="Área total (m²)"
          value={pvSyst?.module_area ?? "Não informado"}
        />
        <DialogInfoItem
          name="Quantidade de módulos"
          value={pvSyst.moduleNumber ?? "Não informado"}
        />
        <DialogInfoItem
          name="Potência do módulo"
          value={pvSyst.moduleUnitNomPower ?? "Não informado"}
        />
        <DialogInfoItem
          name="Modelo do Módulo"
          value={pvSyst.moduleModel ?? "Não informado"}
        />
        <DialogInfoItem
          name="Fabricante do Módulo"
          value={pvSyst.moduleManufactor ?? "Não informado"}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography sx={{ fontWeight: "bold" }}>Strings</Typography>
        <DialogInfoItem
          name="Quantidade"
          value={pvSyst.stringNumber ?? "Não informado"}
        />
        <DialogInfoItem
          name="Tamanho"
          value={pvSyst.stringLength ?? "Não informado"}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography sx={{ fontWeight: "bold" }}>Inversores</Typography>
        <DialogInfoItem
          name="Quantidade de inversores"
          value={pvSyst.inverterNumber ?? "Não informado"}
        />
        <DialogInfoItem
          name="Potência do inversor"
          value={pvSyst.inverterUnitNomPower ?? "Não informado"}
        />
        <DialogInfoItem
          name="Potência total dos inversores"
          value={pvSyst.inverterTotalPower ?? "Não informado"}
        />
        <DialogInfoItem
          name="Modelo do Inversor"
          value={pvSyst.inverterModel ?? "Não informado"}
        />
        <DialogInfoItem
          name="Fabricante do Inversor"
          value={pvSyst.inverterManufactor ?? "Não informado"}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography sx={{ fontWeight: "bold" }}>STC Nominal</Typography>
        <DialogInfoItem
          name="STC Nominal"
          value={pvSyst.nominal_STC ?? "Não informado"}
        />
      </Grid>
    </Grid>
  );
}
